class NumberOfImagesManager {
  numberOfImages = [
    {
      number: 1,
      batch_size: 1,
      batch_count: 1,
    },
    {
      number: 2,
      batch_size: 2,
      batch_count: 1,
    },
    {
      number: 4,
      batch_size: 2,
      batch_count: 2,
    },
    {
      number: 9,
      batch_size: 3,
      batch_count: 3,
    },
    {
      number: 16,
      batch_size: 2,
      batch_count: 8,
    },
  ];

  constructor() {
  }

  getByNumber(number) {
    return this.numberOfImages.find(obj => obj.number === number);
  }

  getByBatchSizeAndCount(size, count) {
    return this.numberOfImages.find(obj => (obj.batch_size === size && obj.batch_count === count));
  }
}

export default new NumberOfImagesManager()